import { Paywall as PaywallComponent } from '@trmediaab/site-offers';
import { Box } from '@trmediaab/zebra';
import { rgba } from 'polished';
import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { VerticalSpacer } from '~/components/Elements';
import Link from '~/components/Link';
import Spinner from '~/components/Spinner';
import { getLoginUrl } from '~/containers/Auth/utils';
import { colors, spacing } from '~/utils/css-mixins';

import { authRefresh, fetchOffers } from './actions';
import {
  selectOffersData,
  selectOffersError,
  selectOffersLoading,
  selectUser,
} from './selectors';

const Fade = styled.div`
  height: 110px;
  margin: -150px ${spacing.siteGutter * -1}px 0;
  position: relative;
  z-index: 1;
  background-image: linear-gradient(
    to bottom,
    ${rgba(colors.white, 0)} 0%,
    ${rgba(colors.white, 1)} 100%
  );
`;

const SmallWrapper = styled.div`
  border: dashed 1px ${colors.border};
  background-color: white;
  padding: ${spacing.siteGutter}px;
  position: relative;
  z-index: 1;
  border-radius: 2px;
  margin: ${spacing.siteGutter}px 0;
  font-size: 14px;
  line-height: 20px;

  a {
    font-weight: 600;
  }

  a:hover {
    cursor: pointer;
  }
`;

const SmallPaywall = ({ name, user }) => (
  <SmallWrapper>
    {name ?? 'Det här'} är en del av Travronden Digital,{' '}
    {user == null ? (
      <Fragment>
        <a href={getLoginUrl()}>logga in</a> eller{' '}
        <Link to={{ type: 'PRODUCTS_PAGE' }}>läs mer här.</Link>
      </Fragment>
    ) : (
      <Link to={{ type: 'PRODUCTS_PAGE' }}>läs mer här.</Link>
    )}
  </SmallWrapper>
);

const CheckoutPaywall = ({ fade, user, isArticle }) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectOffersLoading);
  const error = useSelector(selectOffersError);
  const data = useSelector(selectOffersData);
  // Pass down orderId that we'll get if the user
  // has returned from a 3-D Secure verification
  const location = useSelector(state => state.location);
  const orderId = location.query?.orderId;

  const products = data != null ? data.products : undefined;
  const campaigns = data != null ? data.campaigns : undefined;

  useEffect(() => {
    dispatch(fetchOffers());
  }, [dispatch]);

  return (
    <Box bg="white">
      {fade ? <Fade /> : <VerticalSpacer margin="40" />}
      <Spinner loading={loading !== false} error={error}>
        {Array.isArray(products) && Array.isArray(campaigns) && (
          <PaywallComponent
            reason={user == null ? 'not_logged_in' : 'unauthorized'}
            contentType={isArticle ? 'article' : 'service'}
            authUrl={getLoginUrl()}
            products={products}
            campaigns={campaigns}
            site="travronden_spel"
            orderId={orderId}
            onAuthentication={() => dispatch(authRefresh())}
          />
        )}
      </Spinner>
    </Box>
  );
};

const Paywall = ({ fade, name, small, isArticle }) => {
  const user = useSelector(selectUser);

  return small ? (
    <SmallPaywall name={name} user={user} />
  ) : (
    <CheckoutPaywall fade={fade} user={user} isArticle={isArticle} />
  );
};

export default Paywall;
